import type { MegaIconId } from "@/lib/content/types";

type MegaMenuIconProps = {
  id: MegaIconId;
  className?: string;
};

/** Minimal angular glyphs — monochrome, matching the S-mark geometry. */
export function MegaMenuIcon({ id, className = "h-5 w-5" }: MegaMenuIconProps) {
  const common = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    className,
    "aria-hidden": true as const,
  };

  switch (id) {
    case "product":
      return (
        <svg {...common}>
          <path d="M4 8.5 12 4l8 4.5v7L12 20l-8-4.5v-7Z" />
          <path d="M12 12v8M4 8.5l8 3.5 8-3.5" />
        </svg>
      );
    case "web":
      return (
        <svg {...common}>
          <rect x="3.5" y="5" width="17" height="14" rx="1" />
          <path d="M3.5 9h17M8 5v4" />
        </svg>
      );
    case "mobile":
      return (
        <svg {...common}>
          <rect x="7" y="3" width="10" height="18" rx="1.5" />
          <path d="M11 17.5h2" />
        </svg>
      );
    case "cloud":
      return (
        <svg {...common}>
          <path d="M7.5 17h9.2a3.3 3.3 0 0 0 .4-6.55 4.5 4.5 0 0 0-8.5-1.4A3.4 3.4 0 0 0 7.5 17Z" />
        </svg>
      );
    case "ai":
      return (
        <svg {...common}>
          <path d="M12 3.5 14.2 9l5.8.4-4.5 3.6 1.4 5.5L12 15.6 7.1 18.5l1.4-5.5L4 9.4 9.8 9Z" />
        </svg>
      );
    case "dxp":
      return (
        <svg {...common}>
          <path d="M4 7h16v10H4z" />
          <path d="M4 10h16M9 7v10" />
        </svg>
      );
    case "industry":
      return (
        <svg {...common}>
          <path d="M4 19V9l5 3V9l5 3V5h6v14H4Z" />
        </svg>
      );
    case "case":
      return (
        <svg {...common}>
          <path d="M5 8h14v11H5z" />
          <path d="M9 8V6.5a3 3 0 0 1 6 0V8" />
        </svg>
      );
    case "insight":
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="7.5" />
          <path d="M12 8.5v4l2.5 2.5" />
        </svg>
      );
    case "about":
    default:
      return (
        <svg {...common}>
          <circle cx="12" cy="9" r="3" />
          <path d="M5.5 19c1.5-3 4-4.5 6.5-4.5S17 16 18.5 19" />
        </svg>
      );
  }
}
